"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _detectPosition = _interopRequireDefault(require("./utils/detectPosition"));
var _getCurrentTime = _interopRequireDefault(require("./utils/getCurrentTime"));
var _parseDateToGermanDateString = _interopRequireDefault(require("@micado-digital/react-ui/utils/parseDateToGermanDateString"));
var _useStationStops = _interopRequireDefault(require("./hooks/useStationStops"));
var _useStationTowns = _interopRequireDefault(require("./hooks/useStationTowns"));
var _useStationStopsByTown = _interopRequireDefault(require("./hooks/useStationStopsByTown"));
var _useTownStationFromURL = _interopRequireDefault(require("./hooks/useTownStationFromURL"));
var _useTownStationFromGPS = _interopRequireDefault(require("./hooks/useTownStationFromGPS"));
var _DownloadButton = _interopRequireDefault(require("./components/DownloadButton"));
var _Intro = _interopRequireDefault(require("./components/Intro"));
var _ReactBusStops = _interopRequireDefault(require("./ReactBusStops.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const GoBackButton = (0, _component.default)(() => import("./components/GoBackButton"));
const RestartButton = (0, _component.default)(() => import("./components/RestartButton"));
const Towns = (0, _component.default)(() => import("./components/Towns"));
const StationsByTown = (0, _component.default)(() => import("./components/StationsByTown"));
const LinesByStation = (0, _component.default)(() => import("./components/LinesByStation"));
const Map = (0, _component.default)(() => import("./components/Map"));
const ReactBusStops = _ref => {
  let {
    facilityIDs,
    lang,
    regions,
    sortArr,
    towns = [],
    downloadFile
  } = _ref;
  const css = (0, _ReactBusStops.default)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  const location = (0, _reactRouterDom.useLocation)();
  const {
    pathname
  } = location;
  const [currentTime, setCurrentTime] = (0, _react.useState)((0, _getCurrentTime.default)());
  const [selectedTown, setSelectedTown] = (0, _react.useState)("");
  const [selectedStationObj, setSelectedStationObj] = (0, _react.useState)({});
  const [selectedPagename, setSelectedPagename] = (0, _react.useState)("intro");
  const [dateString, setDateString] = (0, _react.useState)();
  const [gpsPosition, setGpsPosition] = (0, _react.useState)({});
  const stationStops = (0, _useStationStops.default)({
    facilityIDs,
    lang,
    regions
  });
  const filteredTowns = (0, _useStationTowns.default)({
    sortArr,
    stationStops,
    whitelist: towns
  });
  const stationStopsByTown = (0, _useStationStopsByTown.default)({
    selectedTown,
    stationStops
  });
  const townAndStationObj = (0, _useTownStationFromURL.default)({
    stationStops
  });
  const townAndStationGPSObj = (0, _useTownStationFromGPS.default)({
    gpsPosition,
    stationStops
  });
  (0, _react.useEffect)(() => {
    if (location.hash === "" && selectedPagename) {
      navigate("".concat(pathname, "#").concat(selectedPagename));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPagename, location.hash]);
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(townAndStationObj)) {
      const {
        id,
        pagename,
        station,
        town
      } = townAndStationObj;
      if (station && town) {
        setSelectedTown(town);
        setSelectedStationObj({
          id,
          pagename,
          title: station
        });
      }
    }
  }, [townAndStationObj]);
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(townAndStationGPSObj)) {
      const {
        id,
        pagename,
        station,
        town
      } = townAndStationGPSObj;
      if (station && town) {
        setSelectedTown(town);
        setSelectedStationObj({
          id,
          pagename,
          title: station
        });
        setSelectedPagename(pagename);
      }
    }
  }, [townAndStationGPSObj]);
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(selectedStationObj)) {
      setTimeout(() => {
        const $busStopLines = document.querySelector(".mco-bus-stops-lines-by-station");
        if ($busStopLines) {
          $busStopLines.scrollIntoView({
            behavior: "smooth"
          });
        }
      }, 150);
    }
  }, [selectedStationObj]);
  (0, _react.useEffect)(() => {
    setDateString((0, _parseDateToGermanDateString.default)(new Date()));
  }, []);
  const handleTownChange = town => {
    navigate("".concat(pathname, "#stations"));
    if (town === selectedTown) return;
    setSelectedTown(town);
    setSelectedStationObj({});
    setSelectedPagename(null);
  };
  const handleStationChange = _ref2 => {
    let {
      id,
      pagename,
      title
    } = _ref2;
    setSelectedStationObj({
      id,
      pagename,
      title
    });
    navigate("".concat(pathname, "#").concat(pagename));
  };
  const handleDateChange = dateString => {
    setDateString(dateString);
  };
  const handleLocateUser = async () => {
    navigate("".concat(pathname, "#map"));
    const position = await (0, _detectPosition.default)();
    setGpsPosition(position);
  };
  const onSelectLocation = () => {
    navigate("".concat(pathname, "#towns"));
  };
  const onBackClick = () => {
    setSelectedTown("");
    setSelectedStationObj({});
  };
  const onRestartClick = () => {
    navigate("".concat(pathname, "#intro"));
    setSelectedStationObj({});
    setSelectedPagename(null);
    setSelectedTown("");
    setDateString((0, _parseDateToGermanDateString.default)(new Date()));
    setCurrentTime((0, _getCurrentTime.default)());
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.reactBusStops, "mco-bus-stops")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.container, "mco-bus-stops__container")
  }, (location === null || location === void 0 ? void 0 : location.hash) === "#intro" && /*#__PURE__*/_react.default.createElement(_Intro.default, {
    currentTime: currentTime,
    dateString: dateString,
    setCurrentTime: setCurrentTime,
    lang: lang,
    onChangeDate: handleDateChange,
    onLocateUser: handleLocateUser,
    onSelectLocation: onSelectLocation
  }), (location === null || location === void 0 ? void 0 : location.hash) !== "#intro" && /*#__PURE__*/_react.default.createElement(GoBackButton, {
    lang: lang,
    onBackClick: onBackClick
  }), (location === null || location === void 0 ? void 0 : location.hash) === "#towns" && /*#__PURE__*/_react.default.createElement(Towns, {
    lang: lang,
    onChangeTown: handleTownChange,
    onLocateUser: handleLocateUser,
    selectedTown: selectedTown,
    towns: filteredTowns
  }), (location === null || location === void 0 ? void 0 : location.hash) !== "#intro" && (location === null || location === void 0 ? void 0 : location.hash) === "#stations" && /*#__PURE__*/_react.default.createElement(StationsByTown, {
    lang: lang,
    onChangeStation: handleStationChange,
    selectedTown: selectedTown,
    selectedStationObj: selectedStationObj,
    stations: stationStopsByTown
  }), (location === null || location === void 0 ? void 0 : location.hash) !== "#intro" && !(0, _isEmpty.default)(selectedStationObj) && (location === null || location === void 0 ? void 0 : location.hash) !== "#map" && /*#__PURE__*/_react.default.createElement(LinesByStation, {
    currentTime: currentTime,
    dateString: dateString,
    lang: lang,
    setCurrentTime: setCurrentTime,
    station: selectedStationObj,
    timeString: currentTime,
    onChangeDate: handleDateChange
  }), (location === null || location === void 0 ? void 0 : location.hash) === "#intro" && downloadFile && /*#__PURE__*/_react.default.createElement(_DownloadButton.default, {
    downloadFile: downloadFile,
    lang: lang
  })), (location === null || location === void 0 ? void 0 : location.hash) !== "#intro" && (location === null || location === void 0 ? void 0 : location.hash) === "#map" && gpsPosition && /*#__PURE__*/_react.default.createElement(Map, {
    gpsPosition: gpsPosition,
    setGpsPosition: setGpsPosition,
    lang: lang,
    onSelectStation: handleStationChange,
    stations: stationStops,
    town: selectedTown
  }), (location === null || location === void 0 ? void 0 : location.hash) !== "#intro" && /*#__PURE__*/_react.default.createElement(RestartButton, {
    lang: lang,
    onRestart: onRestartClick
  }));
};
var _default = exports.default = ReactBusStops;